import { render, staticRenderFns } from "./DigikalaSettings.vue?vue&type=template&id=438cb16e&scoped=true"
import script from "./DigikalaSettings.vue?vue&type=script&lang=js"
export * from "./DigikalaSettings.vue?vue&type=script&lang=js"
import style0 from "./DigikalaSettings.vue?vue&type=style&index=0&id=438cb16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438cb16e",
  null
  
)

export default component.exports